module.exports = __webpack_public_path__ + "media/images/icon_interview-aba61a21aa4fe1839f21e8884dc0d2d4.png";